
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'

import { Container } from '@/components/Container'
import { Heading } from '@/components/Heading'
import { Text } from '@/components/Text'
import { Button } from '@/components/Button'

export default defineComponent({
  name: 'SectionHero',
  components: { Container, Heading, Text, Button },
  setup() {
    const { push } = useRouter()

    const navigateToUpload = () => push({ name: 'Upload' })
    const navigateToMyUploads = () => push({ name: 'MyUploads' })

    return { navigateToUpload, navigateToMyUploads }
  },
})
